module.exports = __webpack_public_path__ + "static/media/MovieRoulette.92df1b6e.png";